module.exports = __webpack_public_path__ + "static/media/mailbox.7b51b8a7.svg";